import React from 'react';
import { motion } from 'framer-motion';
const spaces = [{
  id: 'patio',
  title: 'Patio Exterior',
  description: 'Un patio acogedor con varias mesas donde disfrutar al aire libre en los días de buen tiempo.',
  image: 'https://cdn.magicpatterns.com/uploads/cLFMUeBUcL2pFPsez4kxct/unnamed_(2).webp',
  reverse: false
}, {
  id: 'salon',
  title: 'Salón Interior',
  description: 'Capacidad para 40-45 comensales en un ambiente cálido y familiar, perfecto para celebraciones.',
  image: 'https://cdn.magicpatterns.com/uploads/4o6UMAKuxdcPBdQQTKPVY2/unnamed.webp',
  reverse: true
}, {
  id: 'cueva',
  title: 'La Cueva',
  description: 'Nuestro espacio más especial: barra para aperitivos, bodega con vinos de la zona y dos salones privados excavados en la roca.',
  image: 'https://cdn.magicpatterns.com/uploads/dhBq2b9YSx7LFnn6pD5gFf/unnamed_(1).webp',
  reverse: false
}, {
  id: 'terraza',
  title: 'Terraza',
  description: 'Los fines de semana se peatonaliza la zona para que las familias disfruten tranquilamente, sin coches.',
  image: 'https://cdn.magicpatterns.com/uploads/pbkbBmxXsYim4oV6nNK99m/unnamed_(3).webp',
  reverse: true
}];
export function SpacesSection() {
  return <section id="espacios" className="py-24 bg-laura-wood text-laura-cream overflow-hidden" data-id="element-296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <div className="text-center mb-20" data-id="element-298">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-amber text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-299">
            Nuestros Espacios
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair mb-6" data-id="element-300">
            Un lugar con encanto
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-laura-beige/80 max-w-2xl mx-auto font-light" data-id="element-301">
            Descubre los diferentes ambientes de nuestro restaurante, cada uno
            con su propia personalidad.
          </motion.p>
        </div>

        <div className="space-y-24" data-id="element-302">
          {spaces.map((space, index) => <div key={space.id} className={`flex flex-col ${space.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-20`} data-id="element-303">
              <motion.div initial={{
            opacity: 0,
            x: space.reverse ? 50 : -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="w-full lg:w-1/2" data-id="element-304">
                <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-305">
                  <div className="absolute inset-0 bg-black/10 z-10" data-id="element-306" />
                  <img src={space.image} alt={space.title} className="w-full h-full object-cover" data-id="element-307" />
                </div>
              </motion.div>

              <motion.div initial={{
            opacity: 0,
            x: space.reverse ? -50 : 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-308">
                <h3 className="text-3xl md:text-4xl font-playfair text-laura-amber mb-6" data-id="element-309">
                  {space.title}
                </h3>
                <p className="text-lg text-laura-cream/90 font-light leading-relaxed" data-id="element-310">
                  {space.description}
                </p>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}